if (!customElements.get('promo-coupon')) {
	customElements.define(
		'promo-coupon',
		class PromoCoupon extends HTMLElement {
			connectedCallback() {
				this.button = this.querySelector('.promo-coupon-inner');
				this.button?.addEventListener('click', this.activate.bind(this));
			}

			activate(event) {
				event.preventDefault();
				event.stopPropagation();

				const code = this.dataset.code;
				if (!code) return;

				// Registers the discount so it is applied automatically at checkout
				fetch('/discount/' + encodeURIComponent(code)).catch(() => {});

				if (navigator.clipboard) {
					navigator.clipboard.writeText(code).catch(() => {});
				}

				this.classList.add('is-activated');
				clearTimeout(this.activatedTimeout);
				this.activatedTimeout = setTimeout(() => {
					this.classList.remove('is-activated');
				}, 4000);
			}
		}
	);
}
